import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// material-ui
import { Avatar, Box, Stack, Typography } from '@mui/material';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';

const GOLD = '#C9A84C';
const GOLD_DARK = '#8B6520';

const getInitial = (user) => {
  if (!user) return '?';
  const src = user.display_name || user.username || user.email || '?';
  return String(src).trim().charAt(0).toUpperCase() || '?';
};

const avatarUrl = (user) => {
  if (!user || !user.avatar) return undefined;
  return user.avatar === 'up' ? '/api/user/avatar' : `/avatars/${user.avatar}.svg`;
};

// ==============================|| SIDEBAR ACCOUNT FOOTER ||============================== //
// Single account entry — no welcome card clutter, no promo / social.

const MenuCard = () => {
  const account = useSelector((state) => state.account);
  const navigate = useNavigate();
  const initial = getInitial(account.user);
  const displayName = account.user?.display_name || account.user?.username || '账号';
  const email = account.user?.email || '';

  return (
    <Box
      onClick={() => navigate('/panel/profile')}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') navigate('/panel/profile');
      }}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        px: 1.25,
        py: 1.1,
        borderRadius: 999,
        cursor: 'pointer',
        border: '1px solid rgba(28,25,23,0.08)',
        background: '#FFFFFF',
        transition: 'border-color .18s ease, background .18s ease, transform .18s ease',
        '&:hover': {
          borderColor: 'rgba(201,168,76,0.4)',
          transform: 'translateY(-1px)'
        }
      }}
    >
      <Avatar
        src={avatarUrl(account.user)}
        sx={{
          width: 36,
          height: 36,
          background: `linear-gradient(135deg, ${GOLD} 0%, ${GOLD_DARK} 100%)`,
          color: '#fff',
          fontWeight: 700,
          fontSize: '0.95rem',
          boxShadow: '0 0 0 1px rgba(201,168,76,0.35)'
        }}
      >
        {initial}
      </Avatar>
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          noWrap
          sx={{ color: '#1C1917', fontWeight: 600, fontSize: 13.5, lineHeight: 1.25, letterSpacing: '-0.01em' }}
        >
          {displayName}
        </Typography>
        {email ? (
          <Typography noWrap sx={{ color: '#A8A29E', fontSize: 11, lineHeight: 1.3 }}>
            {email}
          </Typography>
        ) : (
          <Typography sx={{ color: '#A8A29E', fontSize: 11 }}>账户与安全</Typography>
        )}
      </Box>
      <Stack alignItems="center" justifyContent="center" sx={{ color: '#C9A84C' }}>
        <KeyboardArrowRightRoundedIcon sx={{ fontSize: 18 }} />
      </Stack>
    </Box>
  );
};

export default MenuCard;
